export default __webpack_public_path__ + "static/media/innvocon.ea7ba0a7.png";